(function ($) {
  'use strict';
  if (!$ || !window.theme) return;

  function syncCartCount(cart) {
    if (!cart) return;
    var $links = $('.sp-cart-link');
    $links.each(function () {
      var $link = $(this);
      var $count = $link.find('.sp-cart-count');
      if (cart.item_count > 0) {
        if (!$count.length) $count = $('<span class="sp-cart-count"></span>').appendTo($link);
        $count.text(cart.item_count);
      } else {
        $count.remove();
      }
    });
  }

  $(function () {
    if (!theme.settings || theme.settings.cartType !== 'drawer') return;

    var $drawer = $('#CartDrawer');
    var drawerAlreadyInitialized = $('.js-drawer-open-cart').is('[aria-expanded]');
    if ($drawer.length && theme.CartDrawer && !drawerAlreadyInitialized) {
      window.SpinkarniaCartDrawer36 = new theme.CartDrawer();
    }

    if (theme.cart && theme.cart.getCart) {
      theme.cart.getCart().then(syncCartCount);
    }

    $('body').on('updateCart.ajaxcart.spinkarnia36', function (evt, cart) {
      syncCartCount(cart);
    });

    /* Fallback for legacy product sections that were not bound by theme.AjaxProduct. */
    $(document).on('submit.spinkarnia36', 'form[action*="/cart/add"]', function (evt) {
      if (evt.isDefaultPrevented() || !theme.cart || !theme.cart.addItemFromForm) return;
      evt.preventDefault();

      var $form = $(this);
      var $button = $form.find('[name="add"], .add-to-cart').first();
      if ($button.prop('disabled') || $form.data('spinkarniaAdding')) return;
      $form.data('spinkarniaAdding', true);
      $button.addClass('btn--loading');

      theme.cart.addItemFromForm($form.serialize())
        .then(function () {
          $form.find('.errors').remove();
          $('body').trigger('added.ajaxProduct');
        })
        .catch(function (request) {
          var message = request && request.responseJSON && request.responseJSON.description ? request.responseJSON.description : 'Nie udało się dodać produktu do koszyka. Spróbuj ponownie.';
          $form.find('.errors').remove();
          $form.prepend('<div class="errors text-center">' + message + '</div>');
        })
        .always(function () {
          $form.data('spinkarniaAdding', false);
          $button.removeClass('btn--loading');
        });
    });

    $(document).on('click.spinkarnia36', '#CartDiscountApply', function () {
      var $input = $('#CartDiscountCode');
      var code = $.trim($input.val());
      if (!code) {
        $input.addClass('ajaxcart__discount-input--error').focus();
        return;
      }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });

    $(document).on('keydown.spinkarnia36', '#CartDiscountCode', function (evt) {
      if (evt.which === 13 || evt.keyCode === 13) {
        evt.preventDefault();
        $('#CartDiscountApply').trigger('click');
      }
    });

    $(document).on('click.spinkarnia36', '.sp-ajaxcart-remove', function () {
      if (!theme.cart || !theme.cart.changeItem) return;
      var $button = $(this);
      var key = $button.attr('data-cart-key');
      if (!key || $button.prop('disabled')) return;
      $button.prop('disabled', true).text('Usuwanie…');
      theme.cart.changeItem(key, 0)
        .then(function (cart) {
          syncCartCount(cart);
          $('body').trigger('added.ajaxProduct');
        })
        .catch(function () {
          $button.prop('disabled', false).text('Usuń');
        });
    });
  });
})(window.theme && window.theme.jQuery ? window.theme.jQuery : window.jQuery);
